// Custom VFG components

<template>

        <div class="wrapper field-input">
            *** THIS Component not finished - cd ***
            <input 
                class="form-control"
                type="text"
                @blur=""
                v-model="value" 
                :disabled="disabled"
                :maxlength="schema.max"
                :placeholder="schema.placeholder"
                :readonly="schema.readonly" >

        </div>
</template>
 
<script>
    export default {
        props: ['text'],
        name: 'InputFv',
        mixins: [ VueFormGenerator.abstractField],
        methods: {
            // triggerValidation() {
            //     this.validate();
            // }
        }
        ,
        data() {
            return {}
        } }
</script>

<style>
    .wrapper {
        width: 100%
    }
</style>

                            
